import { useContext } from 'react';

import { StudiesContext } from '../contexts';

// ----------------------------------------------------------------------

const useStudies = () => {
  const context = useContext(StudiesContext);

  if (!context) throw new Error('Studies context must be use inside StudiesProvider');

  return context;
};

export default useStudies;
